import { ThrottleButton } from '@eastcoal/common/components/Button/ThrottleButton'

import { useAuthorizedResource } from '@eastcoal/auth/hooks/useAuthorizedResource'
import { useBelongOwnData } from '@eastcoal/auth/hooks/useBelongOwnData'

import { ActionButtonProps } from './interface'

const HIDDEN_STYLE = {
  display: 'none'
}

export const ActionButton = ({
  ref,
  uuid,
  onlyAdministrator,
  dataOwner,
  disabled: externalDisabled,
  forbiddenStrategy = 'hidden',
  ...buttonProps
}: ActionButtonProps) => {
  const belongToOwn = useBelongOwnData(dataOwner)
  const authorized = useAuthorizedResource(uuid, onlyAdministrator)
  const pass = belongToOwn && authorized
  const disabled = externalDisabled || !pass
  if (forbiddenStrategy !== 'hidden' || !disabled) {
    return <ThrottleButton ref={ref} disabled={disabled} {...buttonProps} />
  }
  return <span ref={ref} style={HIDDEN_STYLE} />
}
